import _ from 'lodash';
import {CORS_PROXY} from './apps_service';

export default class NewsService {
  constructor(SeldaAPIService, $q, $http) {
    'ngInject';
    Object.assign(this, {SeldaAPIService, $q, $http});
  }

  /**
   * Retrieve list of all news or filtered by office
   */
  list(id) {
    return this.SeldaAPIService.requestService('news', {sedi: id ? id : ''});
  }

  carousel() {
    return this.$http.get(`${CORS_PROXY}http://www.federmanager.it/wp-json/wp/v2/posts?filter%5Bfm_slideshow%5D=1`)
      .then(_.property('data'))
      .then((news) => _.sortBy(news, 'ordinamento'));
  }

  newsContent(newsId, officeId) {
    let params = {id: newsId, id_sede: officeId};
    return this.SeldaAPIService.requestService('contenutoNews', params)
    // service returns an array with objects, if any content is located at content element
      .then((response) => response.length ? response[0].content : null);
  }

  fullNews(newsId, officeId) {
    console.debug(`Returning full news for news ${newsId} in office ${officeId}`);
    let newsPromise = this.list(officeId).then(news => _(news).find(n => n.id_elemento == newsId));
    let contentPromise = this.newsContent(newsId, officeId);
    return this.$q.all([newsPromise, contentPromise])
      .then(result => _.extend(result[0], {content: result[1]}));
  }
}


// WEBPACK FOOTER //
// ./client/app/services/news_service.js